module.exports = __webpack_public_path__ + "media/add/divider-2-339a07bb.jpg";